module.exports = __webpack_public_path__ + "media/images/icons/sun-c2c0b46d67bcf226797675e1391d7882.svg";